import { Scope } from '../shared';

export const accountSettings = {
  id: 'accountSettingsStandalone',
  name: _TL_('Preferences'),
  children: [
    {
      id: 'accountSettingsEdit',
      name: _TL_('Account settings edit'),
      route: 'Settings/Account/Edit',
      scope: [Scope.Account],
    },
  ],
};

export const managerAccountSettings = {
  id: 'managerAccountSettingsStandalone',
  name: _TL_('Preferences'),
  children: [
    {
      id: 'managerAccountSettingsEdit',
      name: _TL_('Manager account settings edit'),
      route: 'Settings/ManagerAccount/Edit',
    },
  ],
};

export const advancedSettings = {
  id: 'advancedSettingsStandalone',
  name: _TL_('Preferences'),
  onlyShowToYahoo: true,
  children: [
    {
      id: 'advancedSettingsEdit',
      name: _TL_('Advanced settings edit'),
      route: 'Settings/AdvancedSettings/Edit',
    }, {
      id: 'accountAdvancedSettings',
      name: _TL_('Advanced settings'),
      route: 'Account/AdvancedSettings',
    },
  ],
};
